import React from 'react'
import PrimaryLayout from '../components/layout/PrimaryLayout'

const Monitoring: React.FC = () => {
    return (
        <PrimaryLayout>

            <h1>Monitoring</h1>

        </PrimaryLayout>
    )
}

export default Monitoring